import React, { createContext, useState } from 'react'
import {txt} from "../components/text"

const Context = createContext()
const {Provider} = Context
const lang = localStorage.getItem("appLang")
console.log("lang is:::",lang)
function ContextProvider(props) {
    const [isModal , setIsModal] = useState(false)
    const [isNewModal , setIsNewModal] = useState(false)
    const [isSubModal , setIsSubModal] = useState(false)
    const [dataState , setDataState] = useState("string");
    const [applang,setAppLang]=useState("en")
    const [modalText,setModalText]=useState("");
    const [showUnlockModal,setShowUnlockModal]=useState(false);
    const [modalType,setModalType]=useState("failure");
    const [modalData,setModalData] = useState({
        title : "Oops",
        body : "Something went wrong.",
        btn : ["YES","NO"]
      })
    const [newModalData , setNewModalData] = useState({
        title : "That's all folks",
        body : "You did a great job , next quiz will be available tommorrow",
        btn : ["Go To Leaderboard"]
      })

      const [subModalData , setSubModalData] = useState({
        title : txt.confirmyoursubs[lang || applang],
        body : txt.activatedt[lang || applang],
        btn : [txt.confirmunlock[lang || applang]]
      })
      console.log("subModalData:::",subModalData) 
      const [endQuesModal,setEndQuesModal] = useState({
        title : "That's all folks",
        body : "You have completed all the questions.",
        btn : ["Unlock More Questions","Check Your Score"]
      })
      const [pageLoader , setPageLoader] = useState(false)

      const toggleModal = (value) => {
        setIsModal(value)
    }

    const toggleSubModal = (value) => {
        setIsSubModal(value)
    }

    const toggleNewModal = (value) => {
        setIsNewModal(value)
    }

    const handlePageLoader = (value) => {
        setPageLoader(value)
    }

    const handleModal = (modalData,showModal) => {
        setModalData(modalData);
        setIsModal(showModal);
      }

      const handleNewModal = (modalData,showModal) => {
        setNewModalData(modalData);
        setIsNewModal(showModal);
      }

      const handleSubModal = (modalData,showModal) => {
        setSubModalData(modalData);
        setIsNewModal(showModal);
      }


    const {children} = props

    return (
        <Provider

                value={{
                    isModal,
                    toggleModal,
                    dataState,
                    modalData,
                    handleModal,
                    pageLoader,
                    handlePageLoader,
                    handleNewModal,
                    isNewModal,
                    toggleNewModal,
                    newModalData,
                    toggleSubModal,
                    handleSubModal,
                    isSubModal,
                    subModalData,
                    modalText,setModalText,
                    showUnlockModal,setShowUnlockModal,
                    modalType,setModalType,
                    applang,setAppLang
                }} >

                    {children}

                </Provider>
    )
}

export {Context, ContextProvider}